import { Icon, Tooltip, Box, Text } from '@chakra-ui/react';
import { FiInfo } from 'react-icons/fi';
import { AuthService } from '../services/AuthService';

export const NoticeBadge = (props: { 
  notice?: string;
  onClick: () => void;
}) => {
  // Only show to staff users and only if notice exists
  if (!AuthService.isStaff || !props.notice) {
    return null;
  }

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    props.onClick();
  };

  return (
    <Tooltip 
      label={
        <Box>
          <Text fontWeight="bold">Staff Notice</Text>
          <Text>{props.notice}</Text>
        </Box>
      } 
      aria-label="Staff notice"
    >
      <Box
        display="inline-flex"

        alignItems="center"
        cursor="pointer"
        onClick={handleClick}
        _hover={{ opacity: 0.7 }}
      >
        <Icon 
          as={FiInfo} 
          color="blue.500" 
          boxSize={4}
        />
      </Box>
    </Tooltip>
  );
};